<template>
  <div class="inquiry_warp">
    <van-overlay :show="inquiryShow" >
      <div class="focus_main">
        <div class="focus_pop">
          <div class="inquiry_title">INQUIRY</div>
          <div class="focut_content">
            <div class="input_read">
              <!-- <p>采购</p> -->
              <van-field type="text" v-model="amount"   placeholder="Please add purchase quantity"  />
              <!-- <p>{{phone}}</p> -->
            </div>
            <van-field
              type="textarea"
              class="text_area "
              placeholder="Please add a brief description"
              :autosize=" { maxHeight:'1.4rem', minHeight:'1.4rem'}"
              placeholder-class="placeholder"
              fixed="true"
              v-model="content"
              name="text"
              maxlength="1000"
              show-word-limit
            />
          </div>
          <div class="submit_btn">
            <span @click="resetForm">Cancel</span>
            <span @click="submit">Submit</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
export default {
  name: "inquiry",
  props:{
    isEdit:{
      type:Boolean,
      default:false,
    }
  },
  components:{
  },
  data() {
    return {
      content:'',
      amount:'',
      inquiryShow:false,
      exInfo:{},
      isLoading:false,
    } 
  },
  computed:{
    ...mapGetters({
      companyId:'company/getCompanyId',
      userInfo:'getUserInfo',
      exhibitionId:'getExhibitionId'
    }),
  },
  methods:{
   //提交 完成后返回上一页  
   ...mapActions({
     addEnquiryNew:'company/addEnquiryNew',
     editEnquiryNew:'company/editEnquiryNew',
     getUserAdvisorySetting:'getUserAdvisorySetting'
   }),
   open(exInfo){
     this.exInfo=exInfo;
     if(this.isEdit){
       this.amount=exInfo.amount;
       this.content=exInfo.remark;
     }
     this.inquiryShow=true;
   },
   async submit(){
    if(this.isLoading){
      return 
    }
    if(!this.amount){
      this.$toast('Please add purchase quantity');
    }
    if(!this.content){
      this.$toast('Please add a brief description');
    }
    if((/.*1[3|4|5|7|8][0-9]{9}.*/.test(this.content))){
      this.$toast.fail('请勿输入手机号');
      return;
    }
    this.isLoading=true;
    if(this.isEdit){
      let opt={
        id:this.exInfo.id,
        opt:{
          remark:this.content,
          amount:this.amount,
          auditState:0
        }
      }
      let result = await this.editEnquiryNew(opt);
      this.isLoading=false;
      if(result.result){
        this.$toast.success('success');
        this.$emit('finish')
      } else {
        this.$toast.fail(result.message || 'fail');
      }
    }else{
      let opt={
        exhibitionId:this.exhibitionId,
        exhibitorId:this.exInfo.exhibitorId,
        productId:this.exInfo.productId,
        userId:this.userInfo.userId,
        remark:this.content,
        productName:this.exInfo.productName,
        amount:this.amount,
        langVersion:'en'
      }
      
      let result = await this.addEnquiryNew(opt);
      this.isLoading=false;
      await this.getUserAdvisorySetting()
      if(result.result){
        this.$toast.success('success');
      } else {
        this.$toast.fail(result.message || 'fail');
      }
    }
    this.resetForm();
   },
   resetForm(){
     this.number = '';
     this.amount="";
     this.content = '';
     this.inquiryShow=false;
   }
  }
};
</script>


<style lang="scss" scoped>
  .inquiry_warp{
    z-index: 200;
    position: relative;
    .focus_main{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .focus_pop {
      width: 5.6rem;
      height:4.46rem;
      padding: 0.35rem 0.35rem 0;
      background: #fff;
      border-radius: 0.15rem;
      position: relative;
      .inquiry_title {
        font-size: 0.3rem;
        text-align: center;
        color: #333;
        line-height: 1.2;
        margin-bottom: 0.23rem;
        letter-spacing: 1px;
        padding-left: 1px;
        font-weight: 600;
      }
      .submit_btn {
        height: .9rem;
        width: 100%;
        display: flex;
        align-items: center;
        position: absolute;
        border-top: 1px solid #d2d3d5;
        left: 0;
        right: 0;
        bottom: 0;
        span {
          display: flex;
          justify-content: center;
          align-items: center;
          height: .89rem;
          border: none;
          border-radius: 0;
          color: #333;
          font-size: 0.3rem;
          width: 100%;
          &:first-child {
            border-right: 1px solid #d2d3d5;
          }
          &:last-child {
            color: #fe5502;
          }
        }
      }
      .focut_content {
        .input_read {
          background: #fff;
          color: #666;
          padding: 0 0.2rem;
          border: solid 1px #e6e6e6;
          display: flex;
          justify-content: space-between;
          height: 0.7rem;
          margin-bottom: 0.2rem;
          align-items: center;
          // line-height: 0.7rem;
          p {
            font-size: 0.26rem;
            width: 30%;
          }
          ::v-deep
          .van-field{
            padding: 0;
            background: transparent;
            line-height: inherit;
            .van-field__word-limit{
              margin-top: 0;
              font-size: 0.24rem;
            }
            input {
            color: #666;
            outline: none;
            background: transparent;
            font-size: 0.26rem;
            box-sizing: border-box;
            }
          } 
        }
        .placeholder {
          font-size: .26rem;
        }
        ::v-deep .text_area {
          border: 1px solid #eee;
          height: 1.4rem;
          padding: 0.1rem 0.2rem;
          box-sizing: border-box;
          width: 100%;
          font-size: 0.26rem;
          line-height: 0.38rem;
          color: #333;
           .van-field__body {
            .van-field__control {
              min-height: 0.95rem;
              font-size: 0.26rem;
              line-height: 0.38rem;
              &::-webkit-input-placeholder {
                /* WebKit browsers */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
              &:-ms-input-placeholder {
                /* Internet Explorer 10+ */
                color: #bfbfbf;
                font-size: 0.26rem;
              }
            }
          }
          .van-field__word-limit {
            font-size: 0.24rem;
            margin-top:-0.05rem;
          }
          
        }
      }
    }
  }
</style>

